module.exports = "<!-- view containerref -->\n<ng-container #vc></ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/components/view-container/view-container.component.html
// module id = ./src/app/player/components/view-container/view-container.component.html
// module chunks = main